var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1 7.21994C16.29 7.21994 15.55 5.93994 16.45 4.36994C16.97 3.45994 16.66 2.29994 15.75 1.77994L14.02 0.789936C13.23 0.319936 12.21 0.599937 11.74 1.38994L11.63 1.57994C10.73 3.14994 9.25 3.14994 8.34 1.57994L8.23 1.38994C7.78 0.599937 6.76 0.319936 5.97 0.789936L4.24 1.77994C3.33 2.29994 3.02 3.46994 3.54 4.37994C4.45 5.93994 3.71 7.21994 1.9 7.21994C0.86 7.21994 0 8.06994 0 9.11994V10.8799C0 11.9199 0.85 12.7799 1.9 12.7799C3.71 12.7799 4.45 14.0599 3.54 15.6299C3.02 16.5399 3.33 17.6999 4.24 18.2199L5.97 19.2099C6.76 19.6799 7.78 19.3999 8.25 18.6099L8.36 18.4199C9.26 16.8499 10.74 16.8499 11.65 18.4199L11.76 18.6099C12.23 19.3999 13.25 19.6799 14.04 19.2099L15.77 18.2199C16.68 17.6999 16.99 16.5299 16.47 15.6299C15.56 14.0599 16.3 12.7799 18.11 12.7799C19.15 12.7799 20.01 11.9299 20.01 10.8799V9.11994C20 8.07994 19.15 7.21994 18.1 7.21994ZM10 13.2499C8.21 13.2499 6.75 11.7899 6.75 9.99994C6.75 8.20994 8.21 6.74994 10 6.74994C11.79 6.74994 13.25 8.20994 13.25 9.99994C13.25 11.7899 11.79 13.2499 10 13.2499Z",
    fill: "#98A2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.4836a1283352e3cb8215b318e5dc2e24.svg";
export { ForwardRef as ReactComponent };